import type { ControllerMap } from "./ControllerRegistry";
import { LOG_PREFIX } from "./constants";
import { dispatchControllerWithWarn } from "./DispatchHelper";

/**
 * 현재 HTTP 라우트 1:1: PHP frontend_controller() → #app script 의 data-controller / data-action
 * = routes/web.php 의 [PHP Controller::class, 'method'] short name + 메소드명.
 */
export class PageApplication {
  constructor(
    private readonly registry: Record<string, ControllerMap>,
  ) {}

  run(): void {
    const { controller, action } = this.readLayoutAttrs();
    if (controller && action) {
      dispatchControllerWithWarn(this.registry, controller, action, "page");
      return;
    }
    if (controller || action) {
      console.warn(
        `${LOG_PREFIX} page: incomplete data-controller / data-action. Expected both (see frontend_controller in PHP / layouts/main.php).`,
        { controller, action },
      );
    }
  }

  private readLayoutAttrs(): { controller: string; action: string } {
    const script = document.querySelector<HTMLScriptElement>(
      'script[src*="app.js"]',
    );
    let controller = script ? (script.getAttribute("data-controller") ?? "").trim() : "";
    let action = script ? (script.getAttribute("data-action") ?? "").trim() : "";
    if (!controller || !action) {
      const page = document.querySelector(".admin-page");
      if (page) {
        controller = (page.getAttribute("data-controller") ?? "").trim() || controller;
        action = (page.getAttribute("data-action") ?? "").trim() || action;
      }
    }
    return { controller, action };
  }
}
